module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/christianity-explored.json
// module id = 436
// module chunks = 218749137812884